/* eslint-disable react/prop-types */
import React from "react";
import ErrorBoundary from "../../../components/errorBoundary/errorBoundary";
import NavbarBottom from "./NavbarBottom";

const Navbar = (props) => {
  let {
    params: { id, short_url },
    hideTitle,
    notifications
  } = props;

  return (
    <ErrorBoundary moduleName="NavbarBottom" {...notifications}>
      <NavbarBottom id={id} short_url={short_url} hideTitle={hideTitle} />
    </ErrorBoundary>
  );
};

export default Navbar;
